import { competitionPlayerSelectors } from './../../competition-player/competition-player.selectors'
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'
import { Observable, of } from 'rxjs'
import { catchError, map, take, timeout } from 'rxjs/operators'
import { NotificationService } from 'src/app/core/notification.service'
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'
import { Actions, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/core/core.state'
import { Member } from 'src/app/features/member/member'
import { memberActions } from 'src/app/features/member/member.actions'
import { memberSelectors } from 'src/app/features/member/member.selectors'
import { competitionStaffActions } from '../../competition-staff/competition-staff.actions'
import { competitionPlayerActions } from '../../competition-player/competition-player.actions'
import { UntilDestroy } from '@ngneat/until-destroy'
import { CompetitionTeam } from '../competition-team'
import { competitionTeamActions } from '../competition-team.actions'
import { CompetitionTeamService } from '../competition-team.service'
import { persistentUserRoleSelectors } from 'src/app/features/role/user-role/persistent-user-role/persistent-user-role.selector'
import { environment } from 'src/environments/environment'
import { competitionTeamSelectors } from '../competition-team.selectors'
@UntilDestroy()
@Component({
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class CompetitionTeamAddMemberModalComponent implements OnInit {
  @Input() role: string
  @Input() team: CompetitionTeam
  @Output()
  invitedPlayer: EventEmitter<any> = new EventEmitter()
  @Output()
  invitedStaffMember: EventEmitter<any> = new EventEmitter()
  public isLoading$: Observable<boolean>
  public selectedMember: Member
  public members$: Observable<Member[]>
  public isSubmitButtonDisabled: boolean = false

  constructor(
    private store: Store<AppState>,
    private bsModalRef: BsModalRef,
    private actions$: Actions,
    private notificationService: NotificationService,
    private bsModalService: BsModalService,
    private competitionTeamService: CompetitionTeamService
  ) {}

  ngOnInit() {}

  public onSearchMember(term: string) {
    this.store.dispatch(
      memberActions.searchManyByParams({
        // TODO should shift to another endpoint as /members is now for admins only
        params: RequestQueryBuilder.create({
          search: {
            $or: [
              {
                email: {
                  [CondOperator.EQUALS_LOW]: term
                }
              }
            ]
          }
        })
      })
    )

    this.members$ = this.store
      .select(memberSelectors.selectAll)
      .pipe(
        map((members) =>
          members.filter(
            (member) =>
              member?.email?.toLowerCase() == term.toLowerCase() ||
              member?.memberNumber == parseInt(term)
          )
        )
      )
  }

  public onSelectMember(member: Member) {
    this.selectedMember = member
  }

  public onFormSubmit(form) {
    this.isSubmitButtonDisabled = true
    // if member is not in DMS -> invite member
    if (!form?.memberId) {
      if (form.role == 'player') {
        this.store
          .select(competitionTeamSelectors.selectInvitedPlayers)
          .pipe(take(1))
          .subscribe((invitedPlayers) => {
            const playerAlreadyInvited = invitedPlayers.some(
              (player) =>
                player.email == form.email && player.teamId == this.team?.id
            )

            if (playerAlreadyInvited) {
              this.notificationService.emit(
                'alerts.personAlreadySelected',
                'warning'
              )

              this.isSubmitButtonDisabled = false
            } else {
              this.invitedPlayer.emit({
                email: form.email,
                number: form.number,
                functionId: form.functionId,
                teamId: this.team?.id
              })

              this.notificationService.emit('success', 'success')
              this.cancel()
            }
          })
      }

      if (form.role == 'staff') {
        this.store
          .select(competitionTeamSelectors.selectInvitedStaffMembers)
          .pipe(take(1))
          .subscribe((selectInvitedStaffMembers) => {
            const staffAlreadyInvited = selectInvitedStaffMembers.some(
              (staff) =>
                staff.email == form.email &&
                staff.teamId == this.team?.id &&
                staff.functionId == form.functionId
            )

            if (staffAlreadyInvited) {
              this.notificationService.emit(
                'alerts.personAlreadySelected',
                'warning'
              )

              this.isSubmitButtonDisabled = false
            } else {
              this.invitedStaffMember.emit({
                email: form.email,
                number: null,
                functionId: form.functionId,
                teamId: this.team?.id
              })

              this.notificationService.emit('success', 'success')
              this.cancel()
            }
          })
      }
    }
    // if member exists in DMS
    else {
      this.store
        .select(persistentUserRoleSelectors.selectSelectedUserRole)
        .pipe(take(1))
        .subscribe((pUr) => {
          const siteId =
            pUr && pUr.siteId ? pUr.siteId : environment.defaultSiteId
          switch (form.role) {
            case 'staff':
              this.store.dispatch(
                competitionStaffActions.createOne({
                  entity: {
                    siteId: siteId,
                    memberId: form.memberId,
                    competitionId: form?.competitionId,
                    competitionTeamId: this.team?.id,
                    competitionStaffFunctionId: form?.functionId
                  }
                })
              )

              this.actions$
                .pipe(
                  ofType(competitionStaffActions.upsertMany),
                  take(1),
                  timeout(5000),
                  catchError(() => of(null))
                )
                .subscribe((action) => {
                  if (!action) {
                    return false
                  }

                  this.store.dispatch(
                    competitionTeamActions.fetchOneById({
                      id: this.team.id,
                      params: RequestQueryBuilder.create({
                        join: [{ field: 'competitionStaff' }]
                      })
                    })
                  )

                  this.notificationService.emit('alerts.success', 'success')
                  this.bsModalService.hide()
                })

              break
            case 'player':
              this.store
                .select(competitionPlayerSelectors.selectEntities)
                .pipe(take(1))
                .subscribe((competitionPlayersEntities) => {
                  let memberAlreadyExist = false
                  this.team?.competitionPlayers?.forEach((playerId) => {
                    if (
                      competitionPlayersEntities[playerId]?.memberId ==
                      form.memberId
                    ) {
                      if (!memberAlreadyExist) {
                        this.notificationService.emit(
                          'alerts.playerAlreadyInTeam',
                          'warning'
                        )
                      }
                      memberAlreadyExist = true

                      this.isSubmitButtonDisabled = false
                      return
                    }
                  })

                  if (!memberAlreadyExist) {
                    this.store.dispatch(
                      competitionPlayerActions.createOne({
                        entity: {
                          siteId: siteId,
                          memberId: form.memberId,
                          competitionTeamId: this.team?.id,
                          number: form.number,
                          competitionPlayerFunctionId: form?.functionId
                        }
                      })
                    )

                    this.actions$
                      .pipe(
                        ofType(competitionPlayerActions.upsertMany),
                        take(1),
                        timeout(5000),
                        catchError(() => of(null))
                      )
                      .subscribe((action) => {
                        if (!action) {
                          return false
                        }

                        this.store.dispatch(
                          competitionTeamActions.fetchOneById({
                            id: this.team.id,
                            params: RequestQueryBuilder.create({
                              join: [{ field: 'competitionPlayers' }]
                            })
                          })
                        )

                        this.notificationService.emit(
                          'alerts.success',
                          'success'
                        )
                        this.bsModalService.hide()
                      })
                  }
                })

              break
            default:
              break
          }
        })
    }
  }

  public cancel() {
    this.bsModalRef.hide()
  }
}
